import $ from 'jquery';

const key = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'UP': 38,
  'DOWN': 40
}

export default class DropdownLight {

  constructor($el) {
    this.root = $el;
    this.button = $el.find(".js-dropdown_btn");
    this.links = this.root.find('.js-dropdown_link');
    this.focusIndex = 0;
    this.numOfLinks = this.links.length;
    this.isOpen = false;

    this.handleEvents();
  }

  handleEvents() {
    this.root.click(() => {
      this.toggleList();
      if (this.isOpen === true){
        this.focusIndex= -1;
      }
    });

    $(document.body).click(() => {
      if (this.isOpen && this.root.hasClass('is-open-add')) {
        this.toggleList();
      }
    });

    this.root.focusout(e => {
      if (this.isOpen &&
          !$(e.relatedTarget).hasClass('js-dropdown_link')) {
        this.focusIndex = 0;
        this.toggleList();
      }
    });

    // keyboard
    this.root.keydown(e => {
      switch (this.isOpen) {
        case true:
		
		  if (key.ENTER !== e.keyCode) {
			e.preventDefault();
			e.stopPropagation();
		  }
		  
          if (key.DOWN === e.keyCode ||
              key.TAB === e.keyCode) {
            this.focusNextItem();
          }

          if (key.UP === e.keyCode) {
            this.focusPrevItem();
          }

          if (key.ESCAPE === e.keyCode){
            this.focusIndex = 0;
            this.toggleList();
            setTimeout(() => this.focusItem(this.root));
          }
          break;

        case false:
          if (key.DOWN === e.keyCode ||
              key.SPACE === e.keyCode ||
              key.ENTER === e.keyCode) {
            this.toggleList();
            this.focusItem(this.links.eq(this.focusIndex));
          }
          break;
      }
    });
  }

  focusNextItem() {

    if (this.focusIndex === this.numOfLinks -1){
      this.focusItem(this.button).next();
    } else {
      this.focusItem(this.getNextItem());
    }

  }

  focusPrevItem() {
    this.focusItem(this.getPrevItem());
  }

  focusItem($item) {
    $item.focus();
  }

  getNextItem() {
    this.focusIndex = Math.min(++this.focusIndex, this.numOfLinks-1);
    return this.links.eq(this.focusIndex);
  }

  getPrevItem() {
    this.focusIndex = Math.max(--this.focusIndex, 0);
    return this.links.eq(this.focusIndex);
  }

  toggleList() {

    this.isOpen = !this.isOpen;

    if (this.shouldPlaceAbove()) {
      this.root.addClass('dcw_dropdown--up');
    } else {
      this.root.removeClass('dcw_dropdown--up');
    }

    this.root.toggleClass('is-open');
    setTimeout(() => {
      this.root.toggleClass('is-open-add');
    })

    this.button.attr('aria-expanded', this.isOpen);

    if (this.isOpen === true) {
      this.button.next().removeClass('dcw_hidden');
    } else {
      this.button.next().addClass('dcw_hidden');
    }

    if(this.isOpen===true){
      if(this.button.attr('aria-controls')==='id_menu_deroulant_regions'){
        this.button.attr('aria-label','Fermer la liste des régions');
      }else{
        this.button.attr('aria-label','Fermer la liste des autres sites SG');
      }
    }else{
      if(this.button.attr('aria-controls')==='id_menu_deroulant_regions'){
        this.button.attr('aria-label','Ouvrir la liste des régions');
      }else{
        this.button.attr('aria-label','Ouvrir la liste des autres sites SG');
      }
    }

  }

  shouldPlaceAbove() {
    return window.innerHeight - this.root[0].getBoundingClientRect().bottom < 128;
  }
}


// WEBPACK FOOTER //
// ./src/components/dropdownlight/dropdownlight.js